import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

export const isOrderDetailsLoadedSelector = (state) => {
  const isLoading = Global.selectOrderDetailsIsLoading(state);

  // Explicitly checking for false, because this can be triggered before the action that sets isLoading = true.
  // The initial value is `undefined`, so it will be only be false when loading is complete
  return isLoading === false;
};

const safeFulfillmentPlanIdSelector = (state, { salesOrderId, fulfillmentPlanId }) => {
  const isOrderDetailsLoaded = isOrderDetailsLoadedSelector(state);
  const linkedFulfillmentPlanIds =
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'fulfillmentPlanIds',
    }) ?? [];

  if (!isOrderDetailsLoaded || linkedFulfillmentPlanIds.includes(fulfillmentPlanId)) {
    return fulfillmentPlanId;
  }

  return linkedFulfillmentPlanIds[0];
};

// This was designed to be used for resolving stale or incorrect Order Details routes.
//
// It is possible for a user to have a route where the fulfillmentPlanId
// is no longer "linked" to the salesOrderId. If the absence of this salesOrder-fulfillmentPlan
// association will break much of the logic further down the component tree, then
// this hook should be used.
export const useSafeFulfillmentPlanId = (salesOrderId, fulfillmentPlanId) => {
  return useSelector((state) => safeFulfillmentPlanIdSelector(state, { salesOrderId, fulfillmentPlanId }));
};
